import { ValidationProps } from 'ui';
import { ComplexValue } from 'app/types-shared';
import { DefaultFilter, DefaultFilterMetadata } from 'app/area/shared/default-filters/types-store';
import { CompanyReportItem, CompanyReportItemValidation, TextValue, MetadataValue, SavedReportCompanyReport } from './types-store';
import { TemplateItem } from './types';

export const ACTION = {
  REQUEST_LANGUAGE_OPTIONS: 'COMPANY_REPORT_ADMIN_FORM:REQUEST_LANGUAGE_OPTIONS',
  RECEIVE_LANGUAGE_OPTIONS: 'COMPANY_REPORT_ADMIN_FORM:RECEIVE_LANGUAGE_OPTIONS',
  FAIL_LANGUAGE_OPTIONS: 'COMPANY_REPORT_ADMIN_FORM:FAIL_LANGUAGE_OPTIONS',

  REQUEST_COMPANY_REPORT: 'COMPANY_REPORT_ADMIN_FORM:REQUEST_COMPANY_REPORT',
  RECEIVE_COMPANY_REPORT: 'COMPANY_REPORT_ADMIN_FORM:RECEIVE_COMPANY_REPORT',
  FAIL_COMPANY_REPORT: 'COMPANY_REPORT_ADMIN_FORM:FAIL_COMPANY_REPORT',

  REQUEST_DELETE_COMPANY_REPORT: 'COMPANY_REPORT_ADMIN_FORM:REQUEST_DELETE_COMPANY_REPORT',
  RECEIVE_DELETE_COMPANY_REPORT: 'COMPANY_REPORT_ADMIN_FORM:RECEIVE_DELETE_COMPANY_REPORT',
  FAIL_DELETE_COMPANY_REPORT: 'COMPANY_REPORT_ADMIN_FORM:FAIL_DELETE_COMPANY_REPORT',

  REQUEST_SAVE_COMPANY_REPORT: 'COMPANY_REPORT_ADMIN_FORM:REQUEST_SAVE_COMPANY_REPORT',
  RECEIVE_SAVE_COMPANY_REPORT: 'COMPANY_REPORT_ADMIN_FORM:RECEIVE_SAVE_COMPANY_REPORT',
  FAIL_SAVE_COMPANY_REPORT: 'COMPANY_REPORT_ADMIN_FORM:FAIL_SAVE_COMPANY_REPORT',

  UPDATE_TEXT_DESCRIPTION: 'COMPANY_REPORT_ADMIN_FORM:UPDATE_TEXT_DESCRIPTION',

  UPDATE_ITEM: 'COMPANY_REPORT_ADMIN_FORM:UPDATE_ITEM',

  CHANGE_LANGUAGE: 'COMPANY_REPORT_ADMIN_FORM:CHANGE_LANGUAGE',
  COPY_LANGUAGE_TO_ALL: 'COMPANY_REPORT_ADMIN_FORM:COPY_LANGUAGE_TO_ALL',

  CLEAR_FORM: 'COMPANY_REPORT_ADMIN_FORM:CLEAR_FORM',

  UPDATE_VALIDATION: 'COMPANY_REPORT_ADMIN_FORM:UPDATE_VALIDATION',
  UPDATE_VALIDATION_BY_KEY: 'COMPANY_REPORT_ADMIN_FORM:UPDATE_VALIDATION_BY_KEY',
  RESET_VALIDATION: 'COMPANY_REPORT_ADMIN_FORM:RESET_VALIDATION',

  REQUEST_TEMPLATE: 'COMPANY_REPORT_ADMIN_FORM:REQUEST_TEMPLATE',
  RECEIVE_TEMPLATE: 'COMPANY_REPORT_ADMIN_FORM:RECEIVE_TEMPLATE',
  FAIL_TEMPLATE: 'COMPANY_REPORT_ADMIN_FORM:FAIL_TEMPLATE',

  UPDATE_TEXT_ITEM: 'COMPANY_REPORT_ADMIN_FORM:UPDATE_TEXT_ITEM',
  UPDATE_TEXT_ITEM_DESCRIPTION: 'COMPANY_REPORT_ADMIN_FORM:UPDATE_TEXT_ITEM_DESCRIPTION',
  REMOVE_TEXT: 'COMPANY_REPORT_ADMIN_FORM:REMOVE_TEXT',
  REMOVE_ALL_TEXTS: 'COMPANY_REPORT_ADMIN_FORM:REMOVE_ALL_TEXTS',
  ADD_TEXT: 'COMPANY_REPORT_ADMIN_FORM:ADD_TEXT',
  UPDATE_TEXTS_VALIDATION: 'COMPANY_REPORT_ADMIN_FORM:UPDATE_TEXTS_VALIDATION',
  RESET_TEXT_VALIDATION: 'COMPANY_REPORT_ADMIN_FORM:RESET_TEXT_VALIDATION',
  RESET_TEXTS_VALIDATION: 'COMPANY_REPORT_ADMIN_FORM:RESET_TEXTS_VALIDATION',
  RESET_ALL_TEXTS_VALIDATION: 'COMPANY_REPORT_ADMIN_FORM:RESET_ALL_TEXTS_VALIDATION',

  UPDATE_METADATA_ITEM: 'COMPANY_REPORT_ADMIN_FORM:UPDATE_METADATA_ITEM',
  REMOVE_METADATA: 'COMPANY_REPORT_ADMIN_FORM:REMOVE_METADATA',
  REMOVE_ALL_METADATA: 'COMPANY_REPORT_ADMIN_FORM:REMOVE_ALL_METADATA',
  ADD_METADATA: 'COMPANY_REPORT_ADMIN_FORM:ADD_METADATA',
  UPDATE_METADATA_VALIDATION: 'COMPANY_REPORT_ADMIN_FORM:UPDATE_METADATA_VALIDATION',
  RESET_METADATA_VALIDATION: 'COMPANY_REPORT_ADMIN_FORM:RESET_METADATA_VALIDATION',
  RESET_ALL_METADATA_VALIDATION: 'COMPANY_REPORT_ADMIN_FORM: RESET_ALL_METADATA_VALIDATION'
};

export class RequestLanguageOptions {
  public type: string = ACTION.REQUEST_LANGUAGE_OPTIONS;
}

export class ReceiveLanguageOptions {
  public type: string = ACTION.RECEIVE_LANGUAGE_OPTIONS;
  constructor(public options: ComplexValue<number>[]) { }
}

export class FailLanguageOptions {
  public type: string = ACTION.FAIL_LANGUAGE_OPTIONS;
}

export class RequestCompanyReport {
  public type: string = ACTION.REQUEST_COMPANY_REPORT;
  constructor(public id: number) { }
}

export class ReceiveCompanyReport {
  public type: string = ACTION.RECEIVE_COMPANY_REPORT;
  constructor(
    public id: number,
    public item: CompanyReportItem,
    public savedReports: SavedReportCompanyReport[],
    public filters: DefaultFilter[],
    public filterMetadata: DefaultFilterMetadata[]
  ) { }
}

export class FailCompanyReport {
  public type: string = ACTION.FAIL_COMPANY_REPORT;
  constructor(public id: number) { }
}

export class RequestDeleteCompanyReport {
  public type: string = ACTION.REQUEST_DELETE_COMPANY_REPORT;
  constructor(public id: number) { }
}

export class ReceiveDeleteCompanyReport {
  public type: string = ACTION.RECEIVE_DELETE_COMPANY_REPORT;
  constructor(public id: number) { }
}

export class FailDeleteCompanyReport {
  public type: string = ACTION.FAIL_DELETE_COMPANY_REPORT;
  constructor(public id: number) { }
}

export class RequestSaveCompanyReport {
  public type: string = ACTION.REQUEST_SAVE_COMPANY_REPORT;
  constructor(public id: number) { }
}

export class ReceiveSaveCompanyReport {
  public type: string = ACTION.RECEIVE_SAVE_COMPANY_REPORT;
  constructor(public id: number, public newCompanyReportId: number) { }
}

export class FailSaveCompanyReport {
  public type: string = ACTION.FAIL_SAVE_COMPANY_REPORT;
  constructor(public id: number) { }
}

export class UpdateTextDescription {
  public type: string = ACTION.UPDATE_TEXT_DESCRIPTION;
  constructor(
    public description: string
  ) { }
}

export class ClearForm {
  public type: string = ACTION.CLEAR_FORM;
}

export class UpdateItem {
  public type: string = ACTION.UPDATE_ITEM;
  constructor(public item: Partial<CompanyReportItem>) { }
}

export class ChangeLanguage {
  public type: string = ACTION.CHANGE_LANGUAGE;
  constructor(public languageId: number, public description: string) { }
}

export class CopyLanguageToAll {
  public type: string = ACTION.COPY_LANGUAGE_TO_ALL;
  constructor(public languageId: number) { }
}

export class UpdateValidation {
  public type: string = ACTION.UPDATE_VALIDATION;
  constructor(public validation: CompanyReportItemValidation) { }
}

export class ResetValidation {
  public type: string = ACTION.RESET_VALIDATION;
  constructor(public key: string) {
  }
}

export class RequestTemplate {
  public type: string = ACTION.REQUEST_TEMPLATE;
  constructor(public id: number) { }
}

export class ReceiveTemplate {
  public type: string = ACTION.RECEIVE_TEMPLATE;
  constructor(
    public item: TemplateItem
  ) { }
}

export class FailTemplate {
  public type: string = ACTION.FAIL_TEMPLATE;
  constructor(public id: number) { }
}

export class UpdateTextItem {
  public type: string = ACTION.UPDATE_TEXT_ITEM;
  constructor(public textValue: TextValue) { }
}

export class UpdateTextItemDescription {
  public type: string = ACTION.UPDATE_TEXT_ITEM_DESCRIPTION;
  constructor(
    public id: number,
    public description: string
  ) { }
}

export class RemoveText {
  public type: string = ACTION.REMOVE_TEXT;
  constructor(public id: number) {
  }
}

export class RemoveAllTexts {
  public type: string = ACTION.REMOVE_ALL_TEXTS;
}

export class AddText {
  public type: string = ACTION.ADD_TEXT;
}

export class UpdateTextsValidation {
  public type: string = ACTION.UPDATE_TEXTS_VALIDATION;
  constructor(public id: number, public validationProps: { [propertyName: string]: ValidationProps }) { }
}

export class ResetTextValidation {
  public type: string = ACTION.RESET_TEXT_VALIDATION;
  constructor(public id: number, public key?: keyof TextValue) {
  }
}

export class ResetTextsValidation {
  public type: string = ACTION.RESET_TEXTS_VALIDATION;
  constructor(public id: number) {
  }
}

export class ResetAllTextsValidation {
  public type: string = ACTION.RESET_ALL_TEXTS_VALIDATION;
}
export class UpdateMetadataItem {
  public type: string = ACTION.UPDATE_METADATA_ITEM;
  constructor(public metadataValue: MetadataValue) { }
}

export class RemoveMetadata {
  public type: string = ACTION.REMOVE_METADATA;
  constructor(public id: number) {
  }
}

export class RemoveAllMetadata {
  public type: string = ACTION.REMOVE_ALL_METADATA;
}

export class AddMetadata {
  public type: string = ACTION.ADD_METADATA;
}

export class UpdateMetadataValidation {
  public type: string = ACTION.UPDATE_METADATA_VALIDATION;
  constructor(public id: number, public validationProps: { [propertyName: string]: ValidationProps }) { }
}

export class ResetMetadataValidation {
  public type: string = ACTION.RESET_METADATA_VALIDATION;
  constructor(public id: number, public key?: keyof MetadataValue) {
  }
}

export class ResetAllMetadataValidation {
  public type: string = ACTION.RESET_ALL_METADATA_VALIDATION;
}
